import {useEffect, type RefObject} from 'react'

export interface ChatComposerPresentation {
  readonly input: HTMLTextAreaElement | null
  readonly submit: HTMLButtonElement | null
  readonly stop: HTMLButtonElement | null
  readonly readOnly: boolean
  readonly validInputActionEnabled: boolean
  readonly hasSubmittableContent: boolean
  readonly actionMode: 'send' | 'steer' | 'queue'
}

export function useChatComposerPresentation(
  onPresentation: ((controls: ChatComposerPresentation) => (() => void) | undefined) | undefined,
  input: RefObject<HTMLTextAreaElement | null>,
  submit: RefObject<HTMLButtonElement | null>,
  stop: RefObject<HTMLButtonElement | null>,
  readOnly: boolean,
  validInputActionEnabled: boolean,
  hasSubmittableContent: boolean,
  actionMode: ChatComposerPresentation['actionMode'],
  showSubmit: boolean,
  showStop: boolean,
) {
  useEffect(
    () =>
      onPresentation?.({
        input: input.current,
        submit: submit.current,
        stop: stop.current,
        readOnly,
        validInputActionEnabled,
        hasSubmittableContent,
        actionMode,
      }),
    [
      onPresentation,
      input,
      submit,
      stop,
      readOnly,
      validInputActionEnabled,
      hasSubmittableContent,
      actionMode,
      showSubmit,
      showStop,
    ],
  )
}
